import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Flex, Text, Link } from "ui-components";
import { CheckCircle, PlusCircleOutline } from "components/Icons";
import FormattedMessage from "components/FormattedMessage";
import HighlightText from "components/HighlightText";
import get from "lodash/get";

const AddOnCard = ({
  onSelect,
  id,
  index,
  label,
  description,
  price,
  strikeOffPrice,
  selected,
  iconColor,
  price_without_tax,
  excludeTax,
  product_link,
  highlightText,
  postfix_label,
  themeColors,
  is5GCompatible,
  name
}) => {
  const [hovered, setHovered] = useState(false);
  const addOnPrice = excludeTax ? price_without_tax : price;
  const additionalStyles = product_link
    ? {
        paddingBottom: "0.8rem"
      }
    : {};
  const ctaColor = get(themeColors?.cta, hovered ? "hoverColor" : "color");
  const disabled = name === "5G" && is5GCompatible !== null && !is5GCompatible;
  return (
    <Box
      sx={{
        opacity: disabled ? 0.4 : 1,
        borderTop: "1px solid silver",
        borderWidth: index ? "1px 0" : "0",
        padding: product_link ? "1rem 0 1.5rem 0" : "1rem 0 1rem 0"
      }}
    >
      <Flex
        alignItems="center"
        justifyContent="space-between"
        data-testid="addon-card"
        sx={additionalStyles}
      >
        <Flex width="80%" alignItems="center">
          <Box
            width="150"
            data-testid="addon-card-check"
            sx={{ cursor: disabled ? "" : "pointer" }}
            onClick={() => (disabled ? {} : onSelect(id, !selected))}
            minWidth="36px"
            onMouseOver={() => setHovered(true)}
            onMouseOut={() => setHovered(false)}
          >
            {selected ? (
              <CheckCircle size="36px" color={ctaColor} />
            ) : (
              <PlusCircleOutline size="36px" color={ctaColor} />
            )}
          </Box>

          <Box
            width={1}
            sx={{ cursor: disabled ? "" : "pointer", wordBreak: "break-word" }}
            onClick={() => (disabled ? {} : onSelect(id, !selected))}
            onMouseOver={() => setHovered(true)}
            onMouseOut={() => setHovered(false)}
          >
            <Text mx={6} mb={1} lineHeight="1.2" fontWeight="700">
              {label}
            </Text>
            {highlightText && (
              <HighlightText
                text={highlightText}
                {...(themeColors?.badge || {})}
              />
            )}
            <Text
              size="sm"
              mx={6}
              lineHeight="1.2"
              style={{ whiteSpace: "pre-line" }}
            >
              {description}
            </Text>
          </Box>
        </Flex>

        <Box minWidth="100px" textAlign="right">
          {postfix_label && (
            <FormattedMessage id={postfix_label} values={{ addOnPrice }} />
          )}
          {strikeOffPrice && (
            <Text lineHeight="1.2" style={{ textDecoration: "line-through" }}>
              {strikeOffPrice}
            </Text>
          )}
          {!postfix_label && <Text lineHeight="1.2">{addOnPrice}</Text>}
        </Box>
      </Flex>
      {product_link && (
        <Link
          href={product_link}
          target="_blank"
          sx={{
            pl: 60,
            lineHeight: "1.2",
            opacity: "0.8",
            textDecoration: "underline !important"
          }}
        >
          <FormattedMessage id="more_details" />
        </Link>
      )}
    </Box>
  );
};

AddOnCard.defaultProps = {
  label: "",
  description: "",
  price: "",
  value: 0
};

AddOnCard.propTypes = {
  onSelect: PropTypes.func,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.number.isRequired
};

export default AddOnCard;
